import React, { useContext } from 'react'
import { FormLayoutRow } from '@pushly/aqe/lib/components'
import { Input } from 'antd'
import { PromptVisitorConditions } from '@pushly/models/lib/structs/prompts/prompt-visitor-conditions'
import { DEFAULT_SCROLL_DEPTH } from '../../constants'
import { PromptEditorContext } from '../../context'

type Props = {
    value: PromptVisitorConditions | undefined
    onChange: (update: PromptVisitorConditions) => void
}

export const ScrollDepthConditionEditor: React.FC<Props> = ({ value, onChange }) => {
    const { loading, selectedPromptIdx } = useContext(PromptEditorContext)

    return (
        <FormLayoutRow
            loading={loading}
            layout="vertical"
            label={null}
            value={
                !loading && (
                    <Input
                        key={selectedPromptIdx}
                        placeholder="0"
                        addonAfter="% of page scrolled"
                        className="vc-scroll-depth"
                        type="number"
                        min={0}
                        max={100}
                        defaultValue={value?.scrollDepthPct ?? DEFAULT_SCROLL_DEPTH}
                        onChange={(ev) => {
                            onChange(
                                PromptVisitorConditions.from({
                                    scrollDepthPct: parseInt(ev.target.value, 10),
                                }),
                            )
                        }}
                    />
                )
            }
        />
    )
}
